/* OutboundSyslogRenderer.js */

"use strict";
const _ = require("lodash");

const AdvancedPreferencesComponent = require("./veil/OutboundSyslogAdvPrefsComponent");
// require("@progress/kendo-ui/js/kendo.dom");
// require("@progress/kendo-ui/js/kendo.core");
require("@progress/kendo-ui/js/kendo.treeview");

/* global $ */

/**
 * @type {{Control:{Action:{Button:ButtonControlComponent}}}}
 * @const
 */
const uiCore = require("@gluenetworks/steve_ui_core");

const ButtonControl = uiCore.Control.Action.Button;
const CheckboxControl = uiCore.Control.Boolean.InputCheckbox;
// const InputNumberControl = uiCore.Control.Textfield.InputNumber;
const InputTextControl = uiCore.Control.Textfield.InputText;

/**
 * class OutboundSyslogRenderer
 *
 * @listens OutboundSyslogComponent#event:DataUpdated
 *
 */
class OutboundSyslogRenderer {
    /**
     *
     * @param {OutboundSyslogComponent} model
     * @param {UiUtils} uiUtils
     */
    constructor(model, uiUtils) {
        this._model = model;
        this._uiUtils = uiUtils;
        this._rootElem = document.createElement("outbound-syslog-gl");
        this._rootElem.classList.add("dark");
        this._rootElem.component = this._model;

        this._headerElem = document.createElement("h1");
        this._headerElem.innerText = "Logging";

        this._formContainer = document.createElement("div");
        this._formContainer.classList.add("primary-form");

        this._enableOutboundSyslogCheckbox = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Enable Syslog",
            title: "Enable Syslog",
        });

        this._host = new InputTextControl({
            darkTheme: true,
            disabled: true,
        });

        this._eventsContainer = document.createElement("div");
        this._eventsContainer.classList.add("events-container");
        this._eventsEl = document.createElement("div");
        this._eventsEl.classList.add("events-list", "k-content");
        this._eventsContainer.appendChild(this._eventsEl);
        this._advancedPrefsButton = new ButtonControl({label: "Configuration", darkTheme: true});
        // this._testSyslogButton = new ButtonControl({ label: "Test Syslog Configuration", darkTheme: true });
        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true,
            disabled: true,
        });
        this._saveButton = new ButtonControl({
            label: "Save",
            active: true,
            darkTheme: true,
            disabled: true,
        });

        this._controlButtonsContainer = document.createElement("div");
        this._controlButtonsContainer.classList.add("control-buttons");
        const leftButtonsCont = document.createElement("div");
        leftButtonsCont.classList.add("left");

        const rightButtonsCont = document.createElement("div");
        rightButtonsCont.classList.add("right");

        this._controlButtonsContainer.appendChild(leftButtonsCont);
        this._controlButtonsContainer.appendChild(rightButtonsCont);

        leftButtonsCont.appendChild(this._advancedPrefsButton.renderer.getRootElement());
        // leftButtonsCont.appendChild(this._testSyslogButton.renderer.getRootElement());

        rightButtonsCont.appendChild(this._cancelButton.renderer.getRootElement());
        rightButtonsCont.appendChild(this._saveButton.renderer.getRootElement());

        // this.kendoTemplate = kendo.template(
        //     `# if (!item.items && item.spriteCssClass) { #
        //     #: item.text #
        //     <span class='k-icon k-i-close kendo-icon'></span>
        //     # } else if(!item.items && !item.spriteCssClass) { #
        //     <span class="k-sprite pdf"></span>
        //     #: item.text #
        //     <span class='k-icon k-i-close telerik-icon'></span>
        //     # } else if (item.items && item.spriteCssClass){ #
        //     #: item.text #
        //     # } else { #
        //     <span class="k-sprite folder"></span>
        //     #: item.text #
        //     # } #`
        // );

        this._onCheck = this._onCheck.bind(this);
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    shutdown() {
        this._unregisterListeners();
        this._uiUtils.clearMessage();
        if (this._slickTable && this._slickTable.destroy) {
            this._slickTable.destroy();
        }
        this._rootElem.remove();

        return Promise.all([
            this._cancelButton.shutdown(),
            this._saveButton.shutdown(),
            this._advancedPrefsButton.shutdown(),
            // this._testSyslogButton.shutdown()
        ]).then(() => {
            this._model = null;
            this._slickContainer = null;
            this._moveRowsPlugin = null;
            this._tableOptions = null;
            this._columns = null;
            this._cancelButton = null;
            this._saveButton = null;
            this._advancedPrefsButton = undefined;
            // this._testSyslogButton = undefined;
            this._controlButtonsContainer = null;
            this._slickTable = null;

            this._rootElem = null;
        });
    }

    _registerListeners() {
        this._advancedPrefsButton.on(
            "UserClick",
            (this._showAdvancedPreferences = this._showAdvancedPreferences.bind(this))
        );
        // this._testSyslogButton.on("UserClick", this._onTestSyslog = this._onTestSyslog.bind(this));
        this._enableOutboundSyslogCheckbox.on(
            "UserValue",
            (this._onEnable = this._onEnable.bind(this))
        );
        this._host.on("UserValue", (this._onHostChange = this._onHostChange.bind(this)));

        this._cancelButton.on("UserClick", (this._onCancel = this._onCancel.bind(this)));
        this._saveButton.on("UserClick", (this._onSave = this._onSave.bind(this)));

        this._model.on("DataUpdated", this._onDataUpdated.bind(this));
    }

    _unregisterListeners() {
        this._advancedPrefsButton.removeAllListeners("UserClick");
        // this._testSyslogButton.removeAllListeners("UserClick");
        this._enableOutboundSyslogCheckbox.removeAllListeners("UserValue");
        this._host.removeAllListeners("UserValue");

        this._cancelButton.removeAllListeners("UserClick");

        this._model.removeAllListeners("DataUpdated");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (this._model) {
            return this._model
                .whenModelIsReady()
                .then(() => {
                    if (this._rootElem) {
                        this._rootElem.innerHTML = "";
                        this._rootElem.appendChild(this._headerElem);
                        this._rootElem.appendChild(this._formContainer);
                        this._formContainer.appendChild(
                            this._enableOutboundSyslogCheckbox.renderer.getRootElement()
                        );
                        // this._enableOutboundSyslogCheckbox.setVisible(this._model._getToggleEnable());
                        this._formContainer.appendChild(
                            this._uiUtils.wrapElement(
                                this._host.renderer.getRootElement(),
                                "Destination Host",
                                "input-container"
                            )
                        );
                        this._rootElem.appendChild(
                            this._uiUtils.wrapElement(this._eventsContainer, "Events", "events")
                        );
                        this._rootElem.appendChild(this._controlButtonsContainer);
                        // convertToKendo(categories, result = [], eventMap = {}, index = 1)
                        this._kendoDataSrc = [];
                        this._eventMap = {};
                        this._eventTextMap = {};
                        this.convertToKendo(
                            this._model._outboundSyslogEntity.getSysLogOptions(),
                            this._kendoDataSrc,
                            this._eventMap,
                            this._eventTextMap
                        ); //this._getKendoData();
                        // console.log(this._kendoDataSrc);
                        // console.log(this._eventMap);
                        // console.log(this._eventTextMap);
                        $(".events-list").kendoTreeView({
                            // template: this.kendoTemplate,
                            expanded: true,
                            dataSource: this._kendoDataSrc,
                            dragAndDrop: false,
                            checkboxes: {
                                checkChildren: true,
                            },
                            loadOnDemand: false,
                            check: this._onCheck,
                        });

                        this._setFormData();
                        this._setControlState();
                        this._toggleActions(!this._model.isDirty());
                        this._registerListeners();
                    }
                    return Promise.resolve();
                })
                .catch((err) => console.error(err) || Promise.reject(err));
        }
    }

    convertToKendo(source, results = [], map = {}, textMap = {}, index = 1) {
        if (index === 1) {
            // Initialise root node of results
            results.push({
                id: index,
                text: "Events",
                expanded: true,
            });
        } else {
            // Add new child node in results
            let opts = {
                id: index,
                text: _.get(source, "category", ""),
                expanded: true,
            };
            if (source.hasOwnProperty("events")) {
                opts.expanded = false;
            }
            results.push(opts);
        }

        // Event list -- Add all events in items and return
        if (source.hasOwnProperty("events")) {
            // Leaf
            const events = _.get(source, "events");
            if (!_.isEmpty(events)) {
                results[results.length - 1].items = [];
                Object.keys(events).forEach((event) => {
                    map[++index] = event;
                    textMap[event] = _.get(events[event], "description", event);
                    results[results.length - 1].items.push({
                        id: index,
                        text: _.get(events[event], "description", event),
                    });
                });
            }
        }
        // Category list -- Recursive call for each category
        else {
            results[results.length - 1].items = [];
            Object.keys(source).forEach((category) => {
                if (category !== "events" && category !== "category") {
                    index = this.convertToKendo(
                        source[category],
                        results[results.length - 1].items,
                        map,
                        textMap,
                        ++index
                    );
                }
            });
        }
        return index;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/
    _toggleActions(toDisable) {
        this._saveButton.setDisabled(toDisable);
        this._cancelButton.setDisabled(toDisable);
    }

    _setFormData() {
        this._enableOutboundSyslogCheckbox.setValue(this._model._enabled);
        this._host.setValue(this._model._outboundSyslogEntity.syslogServerAddress);

        let treeview = $(".events-list").data("kendoTreeView");
        //['dmDeviceDetectRun', 'dmNetworkDiscoveryRun', 'dmDeviceImportRun', 'dmDeviceRebootRun', 'dmAdhocQueryRun', 'cdaAuditPolicyRun', 'cdaCaptureRun', 'provFeat', 'provScript', 'provRenewCert', 'provTransferOs', 'provUpgradeOs', 'provReboot', 'agentIntfcDisable', 'agentIntfcEnable', 'agentConfigRestore', 'osmOsImageDeployRun', 'osmOsImageTransferRun'];
        const events = Object.keys(this._model._outboundSyslogEntity.events);
        events.forEach((event) => {
            const node = treeview.findByText(this._eventTextMap[event]);
            let eventNode = treeview.dataItem(node);
            // Suppressing the error of eventNode being undefined when
            // a saved event is no longer available in syslog options
            if (eventNode) {
                eventNode.set("checked", true);
            }
        });
    }

    _setControlState() {
        // this._enableOutboundSyslogCheckbox.setDisabled(!this._model._enabled);
        this._host.setDisabled(!this._model._enabled);
        // this._testSyslogButton.setDisabled(!this._model._enabled);
        // disable events
        if (!this._model._enabled) {
            $(".k-treeview input.k-checkbox").attr("disabled", "disabled");
            $(".k-treeview .k-Icon").addClass("k-minus-disabled");
            $(".k-treeview .k-in").addClass("k-state-disabled");
        } else {
            $(".k-treeview input.k-checkbox").removeAttr("disabled", "disabled");
            $(".k-treeview .k-Icon").removeClass("k-minus-disabled");
            $(".k-treeview .k-in").removeClass("k-state-disabled");
        }
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/
    _checkedNodeIds(nodes, checkedNodes) {
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].checked) {
                // console.log(nodes[i]);
                checkedNodes.push(nodes[i].id);
            }

            if (nodes[i].hasChildren) {
                this._checkedNodeIds(nodes[i].children.view(), checkedNodes);
            }
        }
    }
    _onCheck() {
        let checkedNodes = [],
            treeView = $(".events-list").data("kendoTreeView");
        this._checkedNodeIds(treeView.dataSource.view(), checkedNodes);
        // console.log(checkedNodes);
        this._selectedEvents = checkedNodes
            .map((item) => this._eventMap[item])
            .filter((item) => !!item);
        this._model._outboundSyslogEntity.events = this._selectedEvents.reduce((acc, item) => {
            acc[item] = true;
            return acc;
        }, {});
        // console.log(this._model._outboundSyslogEntity.events);
        this._toggleActions(!this._model._outboundSyslogEntity.isDirty());
    }

    _onDataUpdated() {
        // this._enableOutboundSyslogCheckbox.setVisible(this._model._getToggleEnable());
        this._onCancel();
    }

    _cancelAction() {
        this._resetData();
    }

    _onSave() {
        this._uiUtils.clearMessage();
        // console.log(this.model._outboundSyslogEntity.properties);
        this._model
            ._validate()
            .then(() => {
                this.model._outboundSyslogEntity
                    .update()
                    .then(() => this._resetData(true))
                    .catch((error) => {
                        if (_.isArray(error)) {
                            error.map((errorMsg) => this._uiUtils.writeErrorMessage(errorMsg));
                        } else if (_.has(error, "errorCode")) {
                            // this._resetData();
                            this._showError(error);
                        } else {
                            console.error(error);
                        }
                        this._saveButton.setDisabled(false);
                        this._cancelButton.setDisabled(false);
                    });
            })
            .catch((err) => {
                this._uiUtils.writeErrorMessage(err);
            });
    }

    _showError(error) {
        if (_.get(error, "errorCode") !== "NoPendingUpdates") {
            this._uiUtils.showMessageDialog({
                message: "An error occurred: " + this._uiUtils.errorCodeMapping(error),
                confirmButtonName: "OK",
            });
        }
    }

    _showAdvancedPreferences() {
        const component = new AdvancedPreferencesComponent(this._model, this._uiUtils);
        this._model._muf
            .displayCustom(component, {notDismissable: false})
            .then((data) => {
                this._model._setAdvData(data);
                this._toggleActions(!this._model._outboundSyslogEntity.isDirty());
            })
            .catch((error) => {
                if (error && !error.userRejected) {
                    console.error("Error in Advanced syslog preferences", error);
                }
            });
    }

    // _onTestSyslog() {
    //     this._model.testSyslog();
    // }

    _onEnable(val) {
        this._model.enableDisablePrefs(val).then(() => {
            this._onCancel(false);
        });
    }

    _onHostChange(val) {
        this._model._outboundSyslogEntity.syslogServerAddress = val;
        this._toggleActions(!this._model._outboundSyslogEntity.isDirty());
    }

    _onCancel() {
        $(".k-treeview input.k-checkbox").removeAttr("disabled", "disabled");
        $(".k-treeview .k-Icon").removeClass("k-minus-disabled");
        $(".k-treeview .k-in").removeClass("k-state-disabled");
        $(".events-list .k-checkbox-wrapper input").each(function () {
            if (this.checked) {
                $(this).prop("checked", false).trigger("change");
            }
        });
        _.delay(() => {
            this._model._outboundSyslogEntity.clearPendingPatches();
            this._model._enabled =
                this._model._outboundSyslogEntity.enabled &&
                this._model._outboundSyslogEntity.tenantId === this._model.activeOrgId;
            this._setFormData();
            this._setControlState();
            this._toggleActions(!this._model.isDirty());
        }, 10);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _resetData() {
        $(".k-treeview input.k-checkbox").removeAttr("disabled", "disabled");
        $(".k-treeview .k-Icon").removeClass("k-minus-disabled");
        $(".k-treeview .k-in").removeClass("k-state-disabled");
        this._setFormData();
        this._setControlState();
        this._toggleActions(!this._model.isDirty());
    }

    // _isDataNotBeenChanged(currentData) {
    //     return _.isEqual(this._getModelData(), currentData);
    // }

    _getModelData() {}

    _deleteItem() {}

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = OutboundSyslogRenderer;
